<template>
  <div :class="validationContainerClass">
    <v-validate :rules="rules" v-slot="{ errors, classes }" :name="label">
      <div class="form-group k-rtl">
        <label :for="id">
          {{ label }}
          <div v-if="isRequired" class="is-required">
            <i class="fas fa-star-of-life"></i>
          </div>
        </label>
        <div>
          <v-select
            :class="[{ invalid: errors && errors.length }, classes]"
            dir="rtl"
            :components="{ Deselect, OpenIndicator }"
            :id="inputID"
            :name="label"
            :ref="name"
            :option-label="placeHolder"
            :placeholder="placeHolder"
            :options="dataSource"
            v-model="modelDataValue"
            :reduce="getValueData"
            :data-value-field="getValueData"
            :getOptionLabel="getFieldData"
            :label="dataTextField"
            :disabled="disabled"
            @input="handleInputForm"
          />

          <span
            class="invalid-feedback"
            :class="{ 'd-block': errors && errors.length }"
          >
            {{ errors[0] }}
          </span>
        </div>
        <span v-if="hasSubtitle" class="form-text m-b-none">
          {{ subtitle }}
        </span>
      </div>
    </v-validate>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default {
  components: { vSelect },
  props: {
    id: {
      default: null,
    },
    name: {
      type: String,
    },
    label: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    dataSource: {
      default: () => [],
    },
    dataTextField: {
      type: String,
    },
    dataValueField: {
      type: String,
    },
    placeHolder: {
      type: String,
    },
    rules: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validationContainerClass: {
      type: String,
    },
    modelValue: Object,
    value: [String, Number],
  },
  data() {
    return {
      OpenIndicator: {
        render: (createElement) =>
          createElement("span", { class: { toggle: false } }),
      },
      Deselect: {
        render: (createElement) =>
          createElement("span", { class: { toggle: false } }),
      },
    };
  },
  computed: {
    modelDataValue: {
      get: function() {
        if(this.value || this.value  == 0) {
          const result = Number(this.value); 

          if(isNaN(result)) return this.value

          return result
        }

        return this.value;
      },
      set: function(val) {
        this.handleInputForm(val);
      },
    },
    inputID() {
      return this.id != null ? this.id : this.name;
    },
    isRequired() {
      return this.rules.includes("required");
    },
    hasSubtitle() {
      return this.subtitle != "";
    },
  },
  methods: {
    handleInputForm(value) {
      this.$emit("update:modelValue", value);

      this.$emit("input", value);
      this.$emit("change", value);
    },
    getFieldData(option) {
      const parts = this.dataTextField.split(".");

      let currentObject = option;

      parts.forEach((part) => {
        if (currentObject) {
          if (currentObject[part] === undefined) {
            currentObject = undefined;
          } else {
            currentObject = currentObject[part];
          }
        } else {
          currentObject = undefined;
        }
      });

      return currentObject;
    },
    getValueData(option) {
      const parts = this.dataValueField.split(".");

      let currentObject = option;

      parts.forEach((part) => {
        if (currentObject) {
          if (currentObject[part] === undefined) {
            currentObject = undefined;
          } else {
            currentObject = currentObject[part];
          }
        } else {
          currentObject = undefined;
        }
      });

      return currentObject;
    },
  },
};
</script>

<style>
.invalid .vs__dropdown-toggle {
  border-color: #e3342f !important;
}
</style>
